import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

import styles from "./QuillEditor.module.scss";

type QuillEditorProps = {
  value: string;
  onChange: (value: string) => void;
  defaultValue?: string;
  style?: React.CSSProperties;
};

const modules = {
  toolbar: [
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    [{ align: [] as string[] }],
    ["link", "image"],
    ["clean"],
    ["undo"],
  ],
  clipboard: {
    matchVisual: false,
  },
};

export const QuillEditor: React.FC<QuillEditorProps> = (props) => {
  const { value, onChange, defaultValue = "", style = {} } = props;

  return (
    <ReactQuill
      value={value}
      defaultValue={defaultValue}
      modules={modules}
      onChange={onChange}
      className={styles.quill}
      style={style}
    />
  );
};
